export default function Team() {
  return (
    <>
      <div
        id="block-nvblockteamindex4"
        className="team-crv section-padding pb-30 !px-2 md:!pl-20"
      >
        <div
          id="team" className="container">
          <div className="row">
            <div className="col-lg-5 valign">
              <div className="content wow fadeInUp" data-wow-delay=".5s">
                <div className="sec-head custom-font !mb-0 ">
                  <h6 id="gradenttext" className="wow  fadeIn leading-[1.8] !font-medium !text-[15px] " data-wow-delay=".5s" >The Team</h6>
                </div>
                <h3 className="co-tit custom-font text-white !font-bold !text-[35px]  mb-15">
                  Driven by the desire to support creators using DeFi, our aim to shape a fresh future where everyone can tokenize their potential.
                </h3>
                <p className=" text-white !text-[14.4px] !font-normal  " >
                  View the LiteDoc to see the most up-to-date list of members
                  and collaborators.
                </p>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-1 sm-mt20 !text-white">
              <div className="img-box">
                <div className="row">
                  <div className="col-sm-6 toright">
                    <div className="full-width d-flex d-sm-block">
                      <div
                        className="img sizxl mb-30"
                        data-tooltip-tit="Yobo Zorle"
                        data-tooltip-sub="Co-founder"
                      >
                        <img
                          src="/img/team/1.png"
                          alt=""
                          className="imago wow"
                        />
                      </div>
                      <div
                        className="img sizmd"
                        data-tooltip-tit="Sargon Cauz"
                        data-tooltip-sub="Marketing Lead"
                      >
                        <img
                          src="/img/team/sargon.png"
                          alt=""
                          className="imago wow"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 toleft valign">
                    <div className="full-width text-left d-flex d-sm-block">
                      <div  
                        className="img sizmd mb-30 "
                        data-tooltip-tit="Zeina "
                        data-tooltip-sub="Business Relations"
                      >
                        <img
                          src="/img/team/zeina.png"
                          alt=""
                          className="imago wow"
                        />
                      </div>
                      <div  
                        className="img sizsm !text-white"
                        data-tooltip-tit="Ben Caeser"
                        data-tooltip-sub="Artist Relations"
                      >
                        <img
                          src="/img/team/ben_caeser.png"
                          alt=""
                          className="imago wow"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>
    </>
  );
}
